import merge from 'lodash/merge'
import * as connectedReactRouter from 'connected-react-router'
import * as authentication from '../lib/authentication'
import * as handlers from './handlers'
import client from './client'
import routes from '../config/routes'

export const DEFAULT_OPTIONS = {
  config: {
    handleSuccess: true,
    handleError: true,
    headers: true
  }
}

export const setAccessToken = () => {
  const token = authentication.getAccessToken()

  const header = {}

  if (!token) return header

  header.Authorization = `Bearer ${token}`
  header['custom-auth'] = `Bearer ${token}`

  return header
}

export const logout = () => {
  authentication.removeAccessToken()

  connectedReactRouter.routerActions.push(routes.login.path)

  window.location.reload()

  return null
}

export const errorInterceptor = async (error) => {
  if (!error?.code) return null

  const { code } = error

  switch (code) {
    case 'E_UNAUTHORIZED_ACCESS':
      return logout()

    default:
      return null
  }
}

export const request = async (method, url, options) => {
  const newHeaders = {
    ...options?.headers,
    ...setAccessToken()
  }

  try {
    const res = await client.request({
      method,
      url,
      data: options?.data,
      params: options?.params,
      headers: newHeaders
    })

    return options?.config?.handleSuccess
      ? handlers.responseSuccess(res, options)
      : res
  } catch (err) {
    const isInternalRoute = !err?.config?.url?.includes('auth')

    if (
      isInternalRoute &&
      err?.response?.data?.errors.includes('E_UNAUTHORIZED_ACCESS')
    ) {
      return logout()
    }

    const errResponse = options?.config?.handleError
      ? handlers.responseError(err, options)
      : err

    return Promise.reject(errResponse)
  }
}

export const get = (url, options) =>
  request('GET', url, merge({}, DEFAULT_OPTIONS, options))

export const post = (url, data, options) =>
  request(
    'POST',
    url,
    merge({}, DEFAULT_OPTIONS, {
      ...options,
      data
    })
  )

export const put = (url, data, options) =>
  request(
    'PUT',
    url,
    merge({}, DEFAULT_OPTIONS, {
      ...options,
      data
    })
  )

export const patch = (url, data, options) =>
  request(
    'PATCH',
    url,
    merge({}, DEFAULT_OPTIONS, {
      ...options,
      data
    })
  )

export const del = (url, options) =>
  request('DELETE', url, merge({}, DEFAULT_OPTIONS, options))
